export const PAGE_LOGIN = 'pg_login';
export const PAGE_HOME = 'pg_home';
export const PAGE_CONTACT = 'page.contact'
export const PAGE_PRIVACY = 'page.privacy'